import Handlebars from 'handlebars';
import toastr from 'toastr';
import NProgress from 'nprogress';
import linkify from 'linkify';
import linkifystring from 'linkifystring';
import linkifyjquery from 'linkifyjquery';
import Settings from '~/settings.js';

import EventHub from '~/eventHub';
import supportticket_template from '~/templates/supportTicket.handlebars';
import customsupportticketdata_template from '~/templates/customreportsfields/customsupportticketdata.handlebars';
import customsupportticketfiles_template from '~/templates/customreportsfields/customsupportticketfiles.handlebars';
import imageResize from '~/services/imageResizeService';
import GeneralView from '~/generalView';
import PrevisualView from '~/views/previsualView';
import getUtilsService from '~/services/utilsService';

var SupportTicketView = GeneralView.View.extend({
	className: 'SupportTicketView',
	supportTicketID: '',
	userid: '',
	commentFiles: [],
	commentFilesCont: 0,
	currentTicketFilesCount: 0,
	varcomments: false,

	initialize: function() {
		toastr.options = {
			"closeButton": true,
			"debug": false,
			"newestOnTop": true,
			"progressBar": false,
			"positionClass": "toast-top-center",
			"preventDuplicates": false,
			"onclick": null,
			"showDuration": "300",
			"hideDuration": "1000",
			"timeOut": "5000",
			"extendedTimeOut": "1000",
			"showEasing": "swing",
			"hideEasing": "linear",
			"showMethod": "fadeIn",
			"hideMethod": "fadeOut"
		}
	},
	
	events: {
		'click #btntogglecomments': 'commentsOpenClose',
		'click #btntogglecomments2': 'commentsOpenClose',
		'click #do-comment': 'savecomment',
		'change #upload' : 'uploadFile',
		'click .discardfile' : 'discardfile',
		'click .file' : 'previsual',
		'click .file_download' : 'downloadFile'
	},
	
	render: function() {
		this.$el.html(Handlebars.template(supportticket_template));
		this.$el.find('#specific-content').hide();
		this.listenTo(EventHub, 'supportTicket:setState', data => {
			this.renderSupportTicket(data.supportTicketID);
		});
		return this;
	},
	
	renderSupportTicket: function(supportTicketID) {
		var that = this;
		Parse.Cloud.run("GetTicket", { 'id': supportTicketID }).then((data) => {
			that.supportTicketID = supportTicketID;
			var supportTicket = data.result.report[0];
			var options = {
				year: 'numeric',
				month: 'short',
				day: 'numeric'
			};
			var langdate = lang + "-GB";
			var datesupportticket = supportTicket.attributes.createdAt.toLocaleDateString(langdate, options);
			var status = '';
			switch(supportTicket.attributes.status){
				case 'open':
					status = 'Abierto';
				break;
				case 'close':
					status = 'Cerrado';
				break;
				case 'discard':
					status = 'Descartado';
				break;
			}
			var datacomments = data.result.reportcomments;
			options = {
				year: 'numeric',
				month: 'short',
				day: 'numeric',
				hour: 'numeric',
				minute: 'numeric'
			}
			var comments = [];
			for (var i = 0; i < datacomments.length; i++) {
				var datecomment = datacomments[i].attributes.createdAt.toLocaleString(langdate, options);
				var commentstring = datacomments[i].attributes.comment;
				var commentAuditor = datacomments[i].attributes.auditor;
				datecomment =  datecomment.toUpperCase();
				var commentid = datacomments[i].id;
				comments.push({attributes:{createdAt: datecomment, comment: commentstring, auditor: commentAuditor, id: commentid, useremail: supportTicket.attributes.userEmail }});
			}
			var params = {
				id: supportTicketID,
				attributes: supportTicket,
				comments: comments,
				datesupportticket: datesupportticket,
				status: status
			};
			var handlebarsTemplate = Handlebars.template(supportticket_template);
			that.$el.html(handlebarsTemplate(params));
			$('.supportticketloader').hide();
			if (datacomments.length > 0) {
				$('.div-coment').show();
				that.varcomments = true;
			}
			var reportFiles = data.result.reportfiles;
			that.currentTicketFilesCount = reportFiles.length;
			for(var i=0; i< reportFiles.length; ++i){
				var name = reportFiles[i].attributes.file._name;
				var title = name.substr(32,name.length-32);
				var url = reportFiles[i].attributes.file._url;
				var content = "<button class='btn btn-default item file' data-url='"+url+"' title='"+title+"'>"+title+" </button>";
				if (reportFiles[i].attributes.comment != undefined) {
					var commentfilecontainer = "#comment-"+  reportFiles[i].attributes.comment.id ;
					$(commentfilecontainer).append(content);
				}
				else{
					$("#files-container").append(content);
				}
			}
			var customSupportTicketData = supportTicket.attributes.customreportvalues.customdata;
			for (var i = 0; i < customSupportTicketData.length; i++) {
				var type = customSupportTicketData[i].type;
				var params = {
					name: customSupportTicketData[i].name, 
					val: customSupportTicketData[i].val
				};
				var handlebarsTemplate = '';
				if (type == "file") {
					handlebarsTemplate = Handlebars.template(customsupportticketfiles_template);
					var nametrime = params.name.replace(/\s/g, '');
					params.nametrim = nametrime;
				}
				else{
					handlebarsTemplate = Handlebars.template(customsupportticketdata_template);
				}
				$("#contentsupportticketdetails").append(handlebarsTemplate(params));
				that.renderfilescustomsupportticket(params, type);
			}
		},
		(error) => {
			console.log(error);
			switch(error.code){
				case 100:
					toastr.error(arrlang[lang]['InternetConnectionError'],'Error');
				break;
			}
		});
	},
	
	renderfilescustomsupportticket: function(params, type){
		if (type == 'file') {
			for (var i = 0; i < params.val.length; i++) {
				var url = params.val[i].url;
				var title = params.val[i].name;
				var title = title.substr(32, title.length-32);
				var re = /(?:\.([^.]+))?$/;
				var ext = re.exec(title.toLowerCase())[1];
				var type = getUtilsService.getFileType(ext);
				var content = '';
				if(type){
					content = "<button class='btn btn-default item file' data-url='"+url+"' title='"+title+"'>"+title+" </button>";
				}
				else{
					content = "<a class='download_link' href='"+url+"' download id='link-"+idtrime+"'></a> <button type='button'class='btn btn-default item file_download' id='buttonlink-"+idtrime+"'>Archivo.docx</button>";
				}
				$('#'+params.nametrim).append(content)
			}
		}
	},
	
	discardfile: function(e){
		e.currentTarget.parentElement.remove();
		var discard = e.currentTarget.id;
		var index;
		if(this.commentFiles.length == 0){
			toastr.info(arrlang[lang]['NoFilestodiscard'],"Información");
		}
		else{
			for (var i = 0; i < this.commentFiles.length; i++) {
				if(this.commentFiles[i]._name == discard){
					index = i;
				}
			}
			this.commentFiles.splice(index, 1);
			this.commentFilesCont--;
		}
	},
	
	uploadFile: function(e){
		var namelenght = e.target.files[0].name.length;
		this.commentFilesCont++;
		var extension = e.target.files[0].name.substring(namelenght-4, namelenght);
		if (extension.charAt(0) != '.'){
			var extension = e.target.files[0].name.substring(namelenght-5, namelenght);
		}
		var that = this;
		var reader = new FileReader();
		var name = 'File_'+(this.commentFilesCont+this.currentTicketFilesCount)+extension;
		$('#filename').fadeIn();
		$('#filename').append("<div title='Descartar archivo'> "+ name +"<i class='fa fa-trash discardfile' id='"+name+"'></i></div><br>");
		$(".discardfile").hover(function(){
			$(this).css("color", "#2F4F4F ");
			$(this).css("cursor", "pointer");
		},
		function(){
			$(this).css("color", "inherit");
		});
		var checkResize = imageResize.checkImage(extension);
		if(checkResize){
			var returnFunc = function(data){
				var b64Data = data.split('base64,')[1];
				var parseFile = new Parse.File(name, { base64: b64Data }, 'image/png');
				that.commentFiles.push(parseFile);
			};
			reader.onload = function (e) {
				imageResize.resizeImage(e.target.result, returnFunc);
			};
			reader.readAsDataURL(e.target.files[0]);
		}
		else{
			reader.onload = function (e) {
				var output = that.getFileStream(e.target.result);
				switch(extension){
					case '.pdf':
						var parseFile = new Parse.File(name, output, 'application/pdf');
					break;
					default:
						var parseFile = new Parse.File(name, output);
					break;
				}
				that.commentFiles.push(parseFile);
			};
			reader.readAsArrayBuffer(e.target.files[0]);
		}
		$('.SaveFilesbtn').prop('disabled', false);
	},
	
	getFileStream: function(file){
		var byteArray = new Uint8Array(file);
		var output = new Array(byteArray.length);
		var i = 0;
		var n = output.length;
		while (i < n) {
			output[i] = byteArray[i];
			i++;
		}
		return output;
	},
	
	downloadFile: function (e){
		var id = $(e.currentTarget).attr('id').split('-')[1];
		$("#link-"+id).get(0).click();
	},

	commentsOpenClose: function() {
		if (this.varcomments === false) {
			this.$el.find('#togglecoments').slideDown('slow');
		}
		else {
			this.$el.find('#togglecoments').slideUp('slow');
		}
		this.varcomments = !this.varcomments;
	},

	savecomment: function() {
		var that = this;
		var comentario = this.$el.find('#commenttxt').val();
		if(comentario != ''){
			Parse.Cloud.run("SendCommentTicket", { 'id': this.supportTicketID, 'comment': comentario }).then((data) => {
				$('#commenttxt').val('');
				var langdate = lang + "-GB";
				var options = {
					year: 'numeric',
					month: 'short',
					day: 'numeric',
					hour: 'numeric',
					minute: 'numeric'
				}
				var date = new Date(data.createdAt);
				var createdAt = date.toLocaleString(langdate, options).toUpperCase();
				var commentHTML = '<li><div class="img-user-coment"><b><span class="item" key="ReportAnonUser">Anónimo</span>:</b><span class="datecomment">'+ createdAt+'.</span></div><div class="coment responsive"><span class="commentdata">'+comentario+'.</span></div><div class="commentfilescontainer files-container" id=comment-'+data.objectId+'></div><div class="separator"></div></li>';
				$('#comment-container').prepend(commentHTML);
				toastr.success("Comentario realizado satisfactoriamente","Operación realizada");
				$('.div-coment').show();
				$('.commentdata').linkify();
				that.SaveFiles(that.supportTicketID, data.objectId);
			},
			(error) => {
				console.log(error);
				switch(error.code){
					case 100:
						toastr.error(arrlang[lang]['InternetConnectionError'],'Error');
					break;
				}
			});
		}
	},

	SaveFiles: function(supportticketid, commentid) {
		var that = this;
		if(this.commentFilesCont > 0){
			$('#loadfilestext').show();
			$('#loadfilesspin').show();
			for(var i = 0; i < this.commentFilesCont; ++i){
				var filex = this.commentFiles[i];
				var name = filex._name;
				var shortName = name.substr(32,name.length-32);
				var tempFile = [{
					name: filex._name,
					base64: filex._source.base64
				}];
				Parse.Cloud.run("SendCommentTicketFile", { 'supportTicketID': supportticketid, 'commentID': commentid, 'file': tempFile }).then(function(result) {
					var createdFile = result.results[0];
					var name = createdFile.file._name;
					var title = name.substr(32,name.length-32);
					var url = createdFile.file._url;
					var content = "<button class='btn btn-default item file' data-url='"+url+"' title='"+title+"'>"+title+" </button>";
					var commentfilecontainer = "#comment-" + createdFile.comment.id;
					$(commentfilecontainer).append(content);
					if(that.commentFilesCont == 1){
						that.commentFilesCont = 0;
						$('#loadfilestext').hide();
						$('#loadfilesspin').hide();
						that.commentFiles= [];
						$('#filename').html('');
					}
					else{
						--that.commentFilesCont;
					}
					that.currentTicketFilesCount++;
					toastr.success("Archivo subido satisfactoriamente","Operación realizada");
				},
				function(error){
					console.log(error);
					switch(error.code){
						case 100:
							toastr.error(arrlang[lang]['InternetConnectionError'],'Error');
						break;
					}
				});
			}
			this.commentFiles = [];
		}
	},

	previsual: function (e){
		var preview = new PrevisualView({file: e.currentTarget.getAttribute("data-url"), title: e.currentTarget.title});
		this.$el.find('#preview').empty();
		this.$el.find('#preview').append(preview.el);
		preview.render();
	},
});
export default SupportTicketView;
